export function getTitleForPackageType(packageType: string) {
    switch (packageType) {
        case 'BRONZE':
            return __('Bronze package');
        case 'SILVER':
            return __('Silver package');
        case 'GOLD':
            return __('Gold package');
        case 'PLATINUM':
            return __('Platinum package');
        case 'CUSTOM':
            return __('Custom package');
        default:
            return __('Custom package');
    }
}
